import React from "react";
import PropTypes from "prop-types";

// Material
import CircularProgress from "@material-ui/core/CircularProgress";

// Hooks
import useTranslate from "../../hooks/useTranslate";

// Components
import Button from "../Button";

// Renders as type="submit" when onClick is omitted, for callers with no
// Formik instance of their own.
const DoneButton = ({
  className,
  disabled,
  isLoading,
  loadingClassName,
  onClick,
  regular
}) => {
  const getText = useTranslate();

  if (isLoading)
    return <CircularProgress className={loadingClassName} size={25} thickness={1} />;

  return (
    <Button
      className={className}
      color="primary"
      disabled={disabled}
      disableElevation
      regular={regular}
      type={onClick ? "button" : "submit"}
      onClick={onClick}
    >
      {getText("common.prompts.done")}
    </Button>
  );
};

DoneButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  loadingClassName: PropTypes.string,
  onClick: PropTypes.func,
  regular: PropTypes.bool
};

DoneButton.defaultProps = {
  className: "",
  disabled: false,
  isLoading: false,
  loadingClassName: "",
  onClick: undefined,
  regular: true
};

export default DoneButton;
